'use client'
import { Box, HStack, Separator, Stack, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'
import CPhoneInput from '../../../PhoneInput'
import { Button } from '@/components/ui/button'
import { CField } from '../../../CField'
import { useSelector } from 'react-redux'
import { IRedux } from '@/_store/types'

function LoginMobile({
  error,
  loading,
  values,
  onChange,
  onLogin,
  children,
}: {
  error: boolean
  loading: boolean
  values: { phone: string; name: string }
  onChange: (name: string, value: string) => void
  onLogin: (e: any, onError: () => void) => void
  children: React.ReactNode
}) {
  const [phoneError, setPhoneError] = useState(false)
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false)

  const t = useTranslations()
  const settings = useSelector((state: IRedux) => state.settings)

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        setIsKeyboardOpen(window.visualViewport.height < window.innerHeight)
      }
    }

    window.visualViewport?.addEventListener('resize', handleResize)
    return () =>
      window.visualViewport?.removeEventListener('resize', handleResize)
  }, [])

  const onTelChange = (val: string) => {
    if (phoneError) setPhoneError(false)

    onChange('phone', val)
  }

  return (
    <Stack
      as='form'
      onSubmit={(e) => onLogin(e, () => setPhoneError(true))}
      style={{ flex: 1 }}
      gap={4}
    >
      <Text color={'text'} fontSize='2xl' fontWeight={700} mb={2}>
        {t('login')}
      </Text>
      <CField
        invalid={phoneError || error}
        errorText={
          phoneError ? t('incorrect_phone_number') : t('error_occured')
        }
      >
        <CPhoneInput
          label={t('phone_number')}
          value={values?.phone}
          onChange={(e) => typeof e === 'string' && onTelChange(e)}
        />
      </CField>
      <Text color={'text'} fontSize='sm' textAlign={'start'}>
        {t('permission_privacy_policy')}{' '}
        <Text as='span' color='primary'>
          {t('terms_of_use')}
        </Text>
      </Text>
      <Button
        type='submit'
        fontSize='md'
        height='56px'
        bg='primary'
        color='primary.text'
        _hover={{
          bg: 'primary.hover',
        }}
        loading={loading}
      >
        {settings?.data?.data?.is_otp ? t('send_code') : t('continue')}
      </Button>

      {!settings?.data?.data?.hide_google_auth ? (
        <Stack flex={1} justify='flex-end'>
          {!isKeyboardOpen && (
            <HStack my={1}>
              <Separator flex='1' />
              <Text color={'gray.700'} flexShrink='0'>
                {t('or')}
              </Text>
              <Separator flex='1' />
            </HStack>
          )}

          <Box>{children}</Box>
        </Stack>
      ) : null}
    </Stack>
  )
}

export default LoginMobile
